const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  device: state => state.app.device,
  sysDic: state => state.app.sysDic,
  tableLoading: state => state.app.tableLoading,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  loginName: state => state.user.login_name,
  userID: state => state.user.user_id,
  userName: state => state.user.name,
  userMobilee: state => state.user.mobile,
  userLevel: state => state.user.level,
  userOldPw:state => state.user.is_oldPw,
  level: state => state.user.level,
  state: state => state.user.state,
  state_name: state => state.user.state_name,
  county: state => state.user.county,
  county_name: state => state.user.county_name,
  town: state => state.user.town,
  town_name: state => state.user.town_name,
  village: state => state.user.village,
  village_name: state => state.user.village_name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  perms: state => state.user.perms,
  trial_version: state => state.user.trial_version,
  setting: state => state.user.setting,
  myDistrictTree: state => state.user.my_district_tree,
  myDistrictCountyTree: state => state.user.my_district_county,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js